<template>
	<modal
		maxWidth="425"
		:exibir="exibir"
		:titulo="titulo"
		@close="fecharModal"
		:custom-actions="false"
		:acao-cancelar="fecharModal"
		:acao-confirmar="tratarEventoSalvar"
		:is-confirmar-desabilitado="desabilitarBotaoSalvar"
		is-confirmar-visivel
		nome-botao-confirmar="Salvar"
	>
		<template #body>
			<v-col>
				<label-personalizado
					nome-campo="Arquivo"
					obrigatorio-por-padrao
					:apresenta-tooltip="exibirTooltipInformativo"
					:mensagem-padrao-tooltip="mensagemTooltipInformativo"
				></label-personalizado>
				<campo-arquivo-novo
					name="arquivo"
					:extensoes-permitidas="extensoesPermitidas"
					:validate="{ required: true }"
					placeholder="Adicionar Arquivo"
					show-selected
					:exibir-campo-modelo="exibirCampoModelo"
					:error-upload.sync="errorUpload"
					@baixar-modelo="tratarEventoBaixarModelo"
					@input="enviarArquivoTemporario"
					@apagar-anexo="apagarAnexo"
				>
					<template v-if="exibirCampoModelo" #modelo>
						<v-col class="pa-0 text-center">
							<h4
								v-for="(url, index) in urlArquivosModelo"
								:key="index"
								@click.stop="tratarEventoBaixarModelo(url)"
							>
								Baixe o modelo {{ getExtensaoArquivo(url) }} aqui
							</h4>
							e importe o arquivo
						</v-col>
					</template>
				</campo-arquivo-novo>

				<template v-if="exibirMensagemAviso">
					<v-alert class="mt-2 text-body-3" dense icon="mdi-alert-circle-outline" type="warning" text>
						{{ mensagemAviso }}
					</v-alert>
				</template>

				<p
					v-if="errorObrigatoriedadeAnexo"
					id="obrigatoriedadeAnexo"
					class="hint-input mb-0 mensagem-erro mt-0"
				>
					O campo é obrigatório
				</p>
			</v-col>
		</template>
	</modal>
</template>

<script>
import { actionTypes } from '@/core/constants'
import CampoArquivoNovo from '@/views/components/CampoArquivoNovo.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { mapState } from 'vuex'

export default {
	name: 'modal-upload',
	components: { CampoArquivoNovo, LabelPersonalizado },
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		exibirTooltipInformativo: {
			type: Boolean,
		},
		extensoesPermitidas: {
			type: Array,
			default() {
				return []
			},
		},
		mensagemTooltipInformativo: {
			type: String,
			default: 'mensagem',
		},
		titulo: {
			type: String,
			default: '',
		},
		exibirCampoModelo: {
			type: Boolean,
		},
		urlArquivosModelo: {
			type: Array,
			default: () => [],
		},
		arquivosModelosEstaticos: {
			type: Boolean,
			default: true,
		},
		idPastaExternaDigital: {
			type: String,
			default: () => '',
		},
		repositorioFlowbee: {
			type: String,
			required: true,
		},
		exibirMensagemAviso: {
			type: Boolean,
			default: false,
		},
		mensagemAviso: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			carregandoArquivo: false,
			idArquivoTemporario: null,
			errorUpload: false,
		}
	},
	computed: {
		...mapState({
			erroCampoArquivoNovo: (state) => state.campoArquivoNovo.erroObrigatoriedade,
		}),
		desabilitarBotaoSalvar() {
			return this.carregandoArquivo || !this.ehFormularioValido
		},
		ehFormularioValido() {
			return this.errors.items.length === 0
		},
		errorObrigatoriedadeAnexo() {
			return !this.ehFormularioValido && this.idArquivoTemporario === null && !this.erroCampoArquivoNovo
		},
	},
	methods: {
		async enviarArquivoTemporario(arquivoTemp) {
			this.carregandoArquivo = true

			await this.$store
				.dispatch(actionTypes.ARQUIVO.ENVIAR_ARQUIVO_TEMPORARIO, this.getFormArquivoTemporario(arquivoTemp))
				.then((arquivo) => {
					this.idArquivoTemporario = arquivo.id
					this.$emit('arquivo-enviado', arquivo)
				})
				.catch(() => (this.errorUpload = true))
				.finally(() => (this.carregandoArquivo = false))
		},
		getFormArquivoTemporario(file) {
			return {
				file: file,
				idExternoPasta: this.idPastaExternaDigital,
				repositorioFlowbee: this.repositorioFlowbee,
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		getExtensaoArquivo(url) {
			const extensao = url.split('.').pop()

			return extensao.toUpperCase()
		},
		async tratarEventoBaixarModelo(url) {
			if (!this.arquivosModelosEstaticos) {
				this.$emit('baixar-modelo', this.getExtensaoArquivo(url))
				return
			}

			const a = document.createElement('a')
			a.href = url
			a.download = ''
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		async tratarEventoSalvar() {
			await this.$validator._base.validateAll()

			if (this.ehFormularioValido) {
				this.$emit('salvar')
			}
		},
		apagarAnexo() {
			this.$emit('apagar-anexo')
		},
	},
}
</script>
<style scoped lang="stylus">
.hint-input
	color #a5a5a5
	margin 0
	font-size 12px

.mensagem-erro
	color #FF5252
</style>
